<template>
    <div v-if="isTrue">
        <div class="shop-box">
            <div class="img-box">
                <img
                    style="border-radius: 5px"
                    :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${detail.quoteImage}`"
                    width="120"
                />
            </div>
            <div class="shop-info-box">
                <p class="shop-name">{{ detail.name }}</p>
                <p>领取数量： 1个</p>
                <p>
                    有效期：
                    <span v-if="detail.longTermStatus === 10">长期</span>
                    <span v-if="detail.longTermStatus === 20"
                        >{{ detail.startTime.slice(0, -9) }}-{{
                            detail.endTime.slice(0, -9)
                        }}</span
                    >
                </p>
            </div>
        </div>
        <van-button class="buttonClass" @click="sureWrite">权益核销</van-button>
    </div>
</template>

<script>
import { getSureCouponDetail, sureWrite } from "@/services/common";
import { Notify } from "vant";
import Cookies from "js-cookie";

export default {
    name: "WriteOff",
    data() {
        return {
            id: "",
            detail: {},
            isTrue: true,
        };
    },
    mounted() {},
    created() {
        const query = this.$route.query;
        this.id = query.id;
        console.log(query, "queryqueryqueryqueryquery");
        const token = Cookies.get("token");
        if (token && token.includes("_merchant")) {
            console.log("获取到了");
            this.getSureCouponDetail();
        } else {
            console.log("没获取到商家token");
            this.$router.push({
                path: "/Login",
                query: { id: this.id },
            });
        }
    },
    methods: {
        getSureCouponDetail() {
            getSureCouponDetail({ activitySendId: this.id }).then((res) => {
                if (res.code === 0) {
                    this.detail = res.data;
                }
            });
        },
        sureWrite() {
            sureWrite({ activitySendId: this.id }).then((res) => {
                console.log(res, "sureWrite");
                if (res.code === 1001) {
                    this.$router.push({
                        path: "/Login",
                        query: { id: this.id },
                    });
                } else if (res.code === 0) {
                    this.isTrue = true;
                    console.log(this.isTrue, "13131313131aa");
                    this.$toast.success("核销成功");
                } else if (res.code === 10005) {
                    this.isTrue = false;
                    Notify({
                        type: "warning",
                        message: res.msg,
                    });
                } else {
                    console.log("1004100410041004");
                    this.isTrue = true;
                    Notify({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
            this.$forceUpdate();
        },
    },
};
</script>

<style lang="less" scoped>
.box {
}

.noBox {
    display: none;
}

.shop-box {
    padding: 10px 0;
    width: 100%;
    //height: 100%;
    //display: flex;
    //border: 5px #9696DD;
    //    0px 0px 0px 0px #9696DD, /*上边阴影 */
    //-2px 0px 0px 0px #9696DD, /*左边阴影  */
    //2px 0px 0px 0px #9696DD, /*右边阴影 */
    //0px 2px 0px 0px #9696DD; /*下边阴影 */
    border-radius: 5px;

    .img-box {
        display: table-cell;
        padding: 0 10px;
        vertical-align: middle;
    }

    .shop-info-box {
        display: table-cell;

        p {
            color: #000000;
            font-size: 14px;
            line-height: 2px;
            margin: 0;

            &.shop-name {
                text-align: center;
                color: #c90606;
                font-size: 18px;
                font-weight: bold;
                line-height: 18px;
                margin-top: 10px;
                margin-bottom: 30px;
                margin-left: 5%;
            }

            &:nth-of-type(2),
            &:nth-of-type(3) {
                color: #999999;
                line-height: 20px;
            }
        }
    }
}

.buttonClass {
    background: linear-gradient(rgba(224, 127, 75), rgba(228, 175, 83));
    color: #ffffff;
    width: 90%;
    margin: 0 5%;
}
</style>
